import styles from './index.module.scss';
import mobileExternalError from '@/assets/img/mobileExternalError.png';

// 移动端页面 - mvp版写法，如果移动端做大做强了会拆出去
export default function MobilePage() {
    return <div className={styles.mobileRoot}>
        <div className={styles.mobileError}>
            <img src={mobileExternalError} className={styles.image} />
            <div className={styles.message}>
                暂不支持移动端访问，请在电脑浏览器内打开
            </div>
        </div>
    </div>;
}
